import config from './config';

export const dashboardProviderConfig = {
  APP_ID: config.APP_ID,
  TENANT_ID: config.TENANT_ID!,
  API_BASE_URL: config.API_BASE_URL_DEFAULT!,
  API_BASE_URL_INVENTORY: config.API_BASE_URL!,
  API_BASE_URL_FIELDS: config.API_BASE_URL_FIELDS!,

  GOOGLE_MAP_API_KEY: config.GOOGLE_MAP_API_KEY!,
  GOOGLE_MAP_VERSION: config.GOOGLE_MAP_VERSION!,

  ALARMS_VIEW_MORE_LINK: config.ALARMS_VIEW_MORE_LINK!,
  MAP_VIEW_MORE_LINK: config.MAP_VIEW_MORE_LINK!,
  TASKS_VIEW_MORE_LINK: config.TASKS_VIEW_MORE_LINK!,
  MACHINE_STATUS_VIEW_MORE_LINK: config.MACHINE_STATUS_VIEW_MORE_LINK!,
  FEED_URL: config.FEED_URL,

  RESOURCES_BASE_URL: config.RESOURCES_BASE_URL!,
};
